import React from 'react'

const Connect = ({ pic, image }) => (
  <div className="col-xs-12 col-sm-4 socMedia ">
    <a href={pic}>
      <img className="codeLogo logoGrow " src={image} alt="Social Media" />
    </a>
  </div>
)

export default Connect



// WEBPACK FOOTER //
// ./src/components/Connect.js